import { render, staticRenderFns } from "./TestProcessIndex.vue?vue&type=template&id=ce4399bc"
import script from "./TestProcessIndex.vue?vue&type=script&lang=js"
export * from "./TestProcessIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports